// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__Evbmz","profileAvatar":"profile_profileAvatar__VwA02","avatarAbbr":"profile_avatarAbbr__3P3Q+"};